import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: {},
    violations: null,
    categories: [],
    isLoadingCategories: false,
    territories: [],
    isLoadingTerritories: false,
    games: [],
    isLoadingGames: false
  },
  actions,
  getters,
  mutations
}
